export const AnalyticEventTypes = {
  VisitedProfile: 1,
  StudentLoggedIn: 2,
  NewChallengeLoaded: 11,
  AnswerChallengeQuestion: 12,
  AnswerBookQuestion: 21,
  OnboardingFinished: 31,
  GoToStore: 51,
  GoToReadBook: 52,
  GoToChallenge: 53,
  GoToRanking: 54,
  GoToLibrary: 55,
  GoToInitialOnboarding: 56,
  GoToHome: 60,
  GoToMyBooks: 61,
}
